import React, { useEffect, useState } from "react";
import { fetchAppointMeeting, getStudentTeacher } from "../../../services/studentService";
import { useUser } from "@clerk/clerk-react";
import { Heading, Box, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalFooter, ModalBody, useToast, useDisclosure } from "@chakra-ui/react";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { fetchTeacherAvailableTime } from "../../../services/studentService";
import './schedule.css';

const Schedule = () => {
  const { user } = useUser();
  const [teacherName, setTeacherName] = useState('');
  const [teacherEmail, setTeacherEmail] = useState('');
  const [teacherId, setTeacherId] = useState('');
  const [events, setEvents] = useState([]);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [eventData, setEventData] = useState(null);

  useEffect(() => {
    const getTeacher = async () => {
      try {
        const { teacherName, teacherEmail, teacherId } = await getStudentTeacher(user.id);

        if (teacherName && teacherEmail && teacherId) {
          setTeacherName(teacherName);
          setTeacherEmail(teacherEmail);
          setTeacherId(teacherId);
          
          const availableTimesObject = await fetchTeacherAvailableTime(teacherId);
          const fetchedEvents = availableTimesObject.events || [];
          
          const formattedEvents = fetchedEvents.map(event => ({
            title: 'Available',
            start: event.start.dateTime,
            end: event.end.dateTime, 
            id: event.id,
          }));

          setEvents(formattedEvents);
        }
      } catch (error) {
        console.error(error);
      }
    };
    getTeacher();
  }, [user.id]);

  const handleEventClick = async (info) => {
    const event = {
      userId: user.id,
      teacherId,
      teacherEmail,
      date: info.event.start.toISOString(),
      time: info.event.start.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}),
      eventId: info.event.id
    };

    setEventData(event);
    onOpen(); 
  };

  const handleConfirm = async () => {
    onClose();
    if(eventData){
      const response = await fetchAppointMeeting(eventData)
      if(response.status===200){
        toast({
          title: 'Meeting scheduled.',
          description: 'Meeting has been scheduled successfully.',
          status: 'success',
          duration: 5000,
          isClosable: true
        })
      } else{
        toast({
          title: 'Error.',
          description: 'Error occured while trying to schedule meeting.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      }
    }
  }

  return (
    <Box padding={2}>
      <Heading>{teacherName}'s Schedule</Heading>
      <Box className="calendar-container" mb={5} p={4}>
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="timeGridWeek"
          events={events}
          eventClick={handleEventClick} 
          selectable={false} 
          height={700} 
          contentHeight={400}
          scrollTime="13:00:00"
          headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: 'timeGridWeek,timeGridDay,dayGridMonth'
          }}
        />
      </Box>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Booking</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <p>Would you like to book a meeting on {eventData?.date} at {eventData?.time}?</p>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={onClose} mr={4}>Cancel</Button>
            <Button colorScheme="teal" onClick={handleConfirm}>Confirm</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Schedule;
